import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useArchiveWorkArea } from 'modules/locations/hooks/useArchiveWorkArea'
import { WorkAreaNodes } from 'modules/locations/hooks/useWorkArea'

interface PropsWorkArea {
  locationId: number
  workArea: NonNullable<WorkAreaNodes>
  disableArchiveButton: boolean
  canManageSpaces: boolean
}

const Options = ({
  locationId,
  workArea,
  disableArchiveButton,
  canManageSpaces,
}: PropsWorkArea) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { archiveWorkArea } = useArchiveWorkArea()
  const archiveWorkarea = (wa: NonNullable<WorkAreaNodes>) => {
    archiveWorkArea({ id: wa.id })
    track(trackingEvents.spaceControl.deleteWorkArea, {})
  }
  const editWorkArea = () => {
    track(trackingEvents.spaceControl.editWorkArea, {})
    navigate({
      pathname: navigation.settings.locations.locationsId.workAreas.workAreaIdEdit.fullPath({
        id: locationId,
        workAreaId: workArea.id,
      }),
    })
  }

  const manageSpacesClick = () => {
    track(trackingEvents.spaceControl.seeOverview, {})
    navigate(
      navigation.settings.locations.locationsId.workAreas.workSpaces.fullPath({
        id: locationId,
        workAreaId: workArea.id,
      })
    )
  }

  return (
    <>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end">
          {canManageSpaces && (
            <PopoverMenu.TouchableOption
              onClick={manageSpacesClick}
              title={i18n.t('settings.locations.location.work_areas.manage_spaces')}
            />
          )}
          <PopoverMenu.TouchableOption
            onClick={editWorkArea}
            title={i18n.t('settings.locations.location.work_areas.edit.title')}
          />
          <PopoverMenu.TouchableOption
            onClick={() => archiveWorkarea(workArea)}
            title={i18n.t('settings.locations.location.work_areas.archive')}
            danger
            disabled={disableArchiveButton}
          />
        </PopoverMenu.Content>
      </PopoverMenu>
    </>
  )
}

export default observer(Options)
